export const formatPrice = (val) => {
  if (val === null || val === undefined || val === "") return "";
  const num = Number(String(val).replace(/[^0-9.]/g, ""));
  if (Number.isNaN(num)) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(num);
};

export const formatDate = (isoDate) => {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate + (isoDate.length === 10 ? "T12:00:00" : ""));
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
    });
  } catch {
    return isoDate;
  }
};

export const formatDateShort = (isoDate) => {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate + (isoDate.length === 10 ? "T12:00:00" : ""));
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return isoDate;
  }
};

export const parseNumericPrice = (val) => {
  if (val === null || val === undefined) return 0;
  const num = Number(String(val).replace(/[^0-9.]/g, ""));
  return Number.isNaN(num) ? 0 : num;
};
